import {useEffect} from 'react';
import {fetchRoomSocketToken} from '../../service/room.service';
import {createRoomSocketConnection, roomSocket} from '../socket';

export function useRoomSocket(roomId: string | undefined): void {
    useEffect(() => {
        if (!roomId)
            return () => {
                // noop
            };

        let cancelled = false;

        fetchRoomSocketToken(roomId).then(({socketToken}) => {
            if (cancelled) return;

            createRoomSocketConnection({roomId}, socketToken);

            if (roomSocket) {
                roomSocket.connect();
            }
        });

        return () => {
            cancelled = true;
            if (roomSocket) {
                roomSocket.disconnect();
                roomSocket.removeAllListeners();
            }
        };
    }, [roomId]);
}
